import { useChat } from "@/context/ChatContext";
import { useLang } from "@/i18n/LanguageContext";
import { Sparkles } from "lucide-react";

/**
 * Small "Ask Andy about this" chip used inline within biomarker / algorithm cards.
 * Pre-fills the chat input with a contextualized question.
 */
export default function AskAndyChip({ prefill, label, size = "sm", testId }) {
  const { openChat } = useChat();
  const { t } = useLang();
  const isXs = size === "xs";

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        openChat({ prefill });
      }}
      className={`inline-flex items-center gap-1.5 rounded-full border border-zinc-200 bg-white font-semibold text-zinc-600 transition hover:border-[color:var(--sentinel)] hover:bg-[color:var(--sentinel-tint)] hover:text-[color:var(--sentinel-darker)] ${
        isXs ? "px-2.5 py-1 text-[10px]" : "px-3 py-1.5 text-xs"
      }`}
      data-testid={testId || "ask-andy-chip"}
      aria-label={label || t.chat.askChip}
    >
      <Sparkles className={isXs ? "h-2.5 w-2.5 text-[color:var(--sentinel)]" : "h-3 w-3 text-[color:var(--sentinel)]"} />
      {label || t.chat.askChip}
    </button>
  );
}
